import {
  Button,
  CardContent,
  Paper,
  Grid,
  DialogActions,
  DialogContentText,
  DialogContent,
  DialogTitle,
  Dialog,
  Box,
  Typography,
} from "@mui/material";
import { submitAnswerMultChoice, useApi } from "../api/Api";
import * as React from "react";
import { useEffect } from "react";
import QuestionMultChoiceSolution from "./QuestionMultChoiceSolution";
import { useTranslation } from "react-i18next";
import QuestionDescription from "./QuestionDescription";

const QuestionMultChoice = ({
  question,
  fetchQuizStats,
  fetchCurrentQuestion,
}) => {
  const { t } = useTranslation();
  const api = useApi();

  const [openAlert, setOpenAlert] = React.useState(false);
  const [feedback, setFeedback] = React.useState("");
  const [correct, setCorrect] = React.useState();
  const [solution, setSolution] = React.useState();
  const [changeQuestion, setChangeQuestion] = React.useState(false);

  const [chosenOptionId, setChosenOptionId] = React.useState();

  let optionsOrder = {};
  question.answers.forEach((option, i) => (optionsOrder[option.id] = i));

  const handleClose = () => {
    setOpenAlert(false);
    setFeedback("");
    if (changeQuestion) fetchCurrentQuestion();
    fetchQuizStats();
  };

  useEffect(() => {
    if (!!feedback) setOpenAlert(true);
  }, [feedback]);

  const submitAnswer = (answerId) => {
    submitAnswerMultChoice(api, answerId)
      .then((response) => {
        let data = response["data"];
        setCorrect(data["correct"]);
        setFeedback(data["feedback"]);
        setSolution(data["solution"]);
        setChangeQuestion(data["change_question"]);
        if (!data["solution"]) setChosenOptionId(null);
      })
      .catch((error) => console.log(error));
  };

  useEffect(() => {
    if (chosenOptionId) submitAnswer(chosenOptionId);
  }, [chosenOptionId]);

  const buttons = question["answers"].map((answer, idx) => (
    <Button
      key={answer["id"]}
      sx={{ mt: 2 }}
      fullWidth={true}
      style={{ textTransform: "none" }}
      variant="contained"
      onClick={() => setChosenOptionId(answer.id)}
    >
      {String.fromCharCode(idx + "A".charCodeAt(0))}) {answer["content"]}
    </Button>
  ));

  return (
    <Grid container justifyContent="center" alignItems="center" spacing={2}>
      <Grid item>
        <Paper elevation={10} sx={{ m: 1, maxWidth: 1000 }}>
          <CardContent>
            {/*<Typography variant="h6" sx={{mb: 1}}>{t("question_type")}: {t("single_choice")}</Typography>*/}
            {/*<Typography variant="h6" sx={{mb: 1}}>{t("question_no")} {question["questionid"]}</Typography>*/}
            {question["img"] ? (
              <Grid
                container
                justifyContent="center"
                alignItems="center"
                sx={{ my: 2 }}
              >
                <img
                  src={question["img"]}
                  style={{ maxHeight: 350, maxWidth: "100%" }}
                  alt={t("question")}
                />
              </Grid>
            ) : (
              <></>
            )}
            <QuestionDescription description={question["description"]} />
            {buttons}
          </CardContent>
        </Paper>
      </Grid>
      <Dialog
        open={openAlert}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {correct ? t("correct_answer") : t("incorrect_answer")}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {feedback}
            {solution === undefined ? (
              <></>
            ) : (
              <Box sx={{ mt: 2 }}>
                <Typography variant="h6">{t("solution")}</Typography>
                <QuestionMultChoiceSolution
                  question={solution}
                  optionsOrder={optionsOrder}
                  chosenOptionId={chosenOptionId}
                />
              </Box>
            )}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>{t("close")}</Button>
        </DialogActions>
      </Dialog>
    </Grid>
  );
};

export default QuestionMultChoice;
